// ANCHOR Base
import { Block } from 'baseui/block';
import { HeadingXSmall } from 'baseui/typography';

// ANCHOR Components
import { constant } from '@lyon/components/utils/constant';
import { LyonUpdateFormCloseButton } from './LyonUpdateFormCloseButton';

// ANCHOR Style
import { BLOCK, TITLE, ACTIONS } from './styles';

export const LyonUpdateFormHeader = constant(() => (
  <Block overrides={BLOCK}>
    <HeadingXSmall overrides={TITLE}>
      Edit Form
    </HeadingXSmall>
    <Block overrides={ACTIONS}>
      <LyonUpdateFormCloseButton />
    </Block>
  </Block>
));
